
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  height:100%;
  padding-top:1.25rem;
}

.career-card{
  display:flex;
  position:relative;
  padding:2rem 1.5rem;
  border:2px solid var(--brand-primary-3);
  color:var(--gray-800);
  height:100%;
}

@media (min-width: 768px){

.career-card{
    padding:1.75rem 2rem 1.75rem;
    width:auto
}
  }

.career-card:hover{
    background:var(--brand-primary-3);
    cursor:pointer;
  }

.career-card:hover slot[name='image']::slotted(*){
      transform:scale(1.05);
    }

.career-card--type{
  position:absolute;
  left:1.5rem;
  top:-1.25rem;
  background:var(--brand-primary-1);
  padding:0.5rem 1.5rem;
  color:var(--brand-neutral-white);
  font-family:var(--ff-dmsans);
  letter-spacing:1px;
  z-index:1;
}

.career-card--content{
  display:flex;
  justify-content:space-between;
  flex-direction:column-reverse;
}

@media (min-width: 768px){

.career-card--content{
    flex-direction:row;
    width:100%
}
  }

.career-card--image{
  display:flex;
  transition:0.5s;
  overflow:hidden;
  height:-moz-fit-content;
  height:fit-content;
}

@media (min-width: 768px){

.career-card--image{
    width:43%;
    justify-content:flex-end;
    max-width:410px
}
  }

.career-card--info{
  display:flex;
  flex-direction:column;
  max-width:250px;
  padding-right:1rem;
}

.career-card--info span{
    padding-bottom:0.25rem;
  }

@media (min-width: 768px){
    .career-card--info.has-image{
      width:100%;
      max-width:57%;
    }

    .career-card--info.no-image{
      width:100%;
      max-width:75% !important;
    }

    .career-card--info span{
      padding-bottom:0.5rem;
    }
  }

.career-card--date{
  font-family:var(--ff-dmsans);
  font-weight:var(--fw-medium);
  font-size:var(--fs-sm);
}

.career-card--location{
  font-family:var(--ff-dmsans);
  font-weight:var(--fw-normal);
  font-size:var(--fs-sm);
  font-style:italic;
}

slot[name='image']{
  display:flex;
  margin-bottom:1rem;
  width:100%;
  overflow:hidden;
}

slot[name='image']::slotted(*){
    width:inherit;
    transition:0.3s;
  }

@media (min-width: 768px){

slot[name='image']{
    margin-bottom:0
}
  }

a{
  color:unset;
  text-decoration:none;
}`;